






import { Vue, Component } from 'nuxt-property-decorator';
import BravadoTheme from '@/components/common/BravadoTheme/BravadoTheme.vue';
import { WAR_ROOM_POSTS_TAB_MYFEED_PAGE } from '@/constants';
import MainPage from '@/components/partials/landings/main-page/MainPage.vue';
import { warRoomStates } from '@/components/partials/war-room/constants';
import { TITLE } from '@/constants/defaultMeta';
import { NoticeMarkup } from '~/components/common/Notice/types';

// @pages index page. Redirect to war room posts if user loggedIn
@Component<HomePage>({
  components: {
    MainPage,
    BravadoTheme,
  },
  layout: 'clear',
  middleware({ redirect, $auth }) {
    if ($auth.loggedIn && $auth.user.warRoomState === warRoomStates.MEMBER) {
      redirect(WAR_ROOM_POSTS_TAB_MYFEED_PAGE);
    }
  },
  mounted() {
    if (!!this.noticeText) {
      this.$notice.error(this.noticeText, undefined, NoticeMarkup.HTML);
    }
  },
})
export default class HomePage extends Vue {
  head() {
    return this.$seo({
      title: TITLE,
      description: 'An exclusive Sales Community for the Best Sales Professionals',
    });
  }

  get noticeText(): string | null {
    switch (this.$route.query.error) {
      case 'deactivated':
        return "Your account is blocked / suspended, please <a style='text-decoration: underline' href='/?dynamic_modal=contact-us'>contact our support</a>.";
      default:
        return null;
    }
  }
}
